<template>
  <div>
    <presentacion-modulo-app :datos="data"></presentacion-modulo-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        "titulo": "",
        "nombreModulo": "Bienvenido al curso" ,
        "texto": "El ABC de las Reservas y los Recursos de Hidrocarburos."
      }
    }
  },
  created() {
    this.$store.commit('nextShow', true)
  }
}
</script>
